/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.ECommerce {
    import fld = ECommRepairItemsBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ECommRepairItemsBOMEditor extends _Ext.BOMGridEditor<ECommRepairItemsBOMRow> { 
        protected getDialogType() { return ECommRepairItemsBOMDialog; }
        protected getLocalTextPrefix() { return ECommRepairItemsBOMRow.localTextPrefix; } 
        constructor(container: JQuery) {
            super(container);

            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as ECommRepairItemsDialog).CalculateTotals();
                }
            });
        } 
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        } 
    }
}